import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWrenchFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" d="m31.486 6.77-5.268 5.269-4.61-1.648-1.647-4.609L25.23.514a9.924 9.924 0 0 0-10.178 2.393 9.925 9.925 0 0 0-2.454 9.985 5.507 5.507 0 0 0-.414.365L1.36 24.08a4.638 4.638 0 0 0 0 6.56 4.638 4.638 0 0 0 6.56 0l10.824-10.824c.133-.133.252-.271.365-.414 3.411 1.063 7.284.25 9.985-2.454A9.925 9.925 0 0 0 31.486 6.77z" /></g></svg>;
export default SvgWrenchFilled;